import { DatePicker, Space } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { Button } from '~/ui';
import styles from './CustomDatePicker.module.scss';
import cn from 'classnames';
import { useState } from 'react';
import i18n from 'i18next';

interface ICustomDatePickerProps {
  title?: string;
  value: [Dayjs | null, Dayjs | null];
  onChange: (name: string, value: Dayjs | null) => void;
  disabledDate?: (current: Dayjs) => boolean;
  showPresets?: boolean;
  format?: string;
  placeholder?: [string, string];
  className?: string;
  disabled?: boolean;
  onBlur?: () => void;
}

const { RangePicker } = DatePicker;

export const CustomDatePicker = ({
  title,
  value,
  disabled,
  onChange,
  showPresets = false,
  disabledDate,
  format = 'DD.MM.YYYY',
  placeholder = [i18n.t('date_from'), i18n.t('date_by')],
  className,
  onBlur,
}: ICustomDatePickerProps) => {
  const [open, setOpen] = useState(false);

  const isPresetActive = (days: number) => {
    if (!value[0] || !value[1]) return false;
    const start = dayjs().subtract(days, 'day').startOf('day');
    const end = dayjs().endOf('day');
    return value[0].isSame(start, 'day') && value[1].isSame(end, 'day');
  };

  const handlePresetClick = (days: number) => {
    onChange('start_date', dayjs().subtract(days, 'day').startOf('day'));
    onChange('end_date', dayjs().endOf('day'));
    setOpen(false);
  };

  return (
    <div className={styles.datePickerWrapper}>
      {title && <span className={styles.dateTitle}>{title}</span>}
      <RangePicker
        disabled={disabled}
        open={open}
        onOpenChange={setOpen}
        value={value}
        format={format}
        className={cn(styles.datePicker, className)}
        placeholder={placeholder}
        disabledDate={disabledDate}
        onBlur={onBlur}
        onChange={dates => {
          if (dates && dates[0] && dates[1]) {
            onChange('start_date', dates[0]);
            onChange('end_date', dates[1]);
            setOpen(false);
          } else {
            onChange('start_date', null);
            onChange('end_date', null);
            setOpen(false);
          }
        }}
        panelRender={panel =>
          showPresets ? (
            <div>
              <div className={styles.extraHeader}>
                <Space>
                  <Button
                    text="7 day"
                    className={cn(
                      styles.selectBtn,
                      isPresetActive(7) && styles.selectBtnActive
                    )}
                    onClick={() => {
                      handlePresetClick(7);
                    }}
                  />
                  <Button
                    text="30 days"
                    className={cn(
                      styles.selectBtn,
                      isPresetActive(30) && styles.selectBtnActive
                    )}
                    onClick={() => {
                      handlePresetClick(30);
                    }}
                  />
                  <Button
                    text="90 days"
                    className={cn(
                      styles.selectBtn,
                      isPresetActive(90) && styles.selectBtnActive
                    )}
                    onClick={() => {
                      handlePresetClick(90);
                    }}
                  />
                </Space>
              </div>
              {panel}
            </div>
          ) : (
            panel
          )
        }
      />
    </div>
  );
};
